"use strict";

// Подключает подсказки на полях с ФИО, емейлом и названием компании.

import urls from "../urls";
const $ = window.jQuery;
const settings = window.DA.settings;
// require("jquery.suggestions");

var BASE_URL = urls.api.demo.getUrl();

function init(callback) {
    if (settings.DISABLE_SUGGESTIONS) {
        return;
    }
    var $form = $("form");
    methods.name($form.find("input[data-suggest='name']"), { onSelect: callback });
    methods.email($form.find("input[data-suggest='email']"), { onSelect: callback });
    methods.party($form.find("input[data-suggest='party']"), { onSelect: callback });
    methods.address($form.find("input[data-suggest='address']"), { onSelect: callback });
}

const initForElement = function (element, type, callbacks = {}) {
    if (type in methods) {
        methods[type]($(element), callbacks);
    }
};

const methods = {
    name: function ($element, callbacks) {
        $element.suggestions({
            serviceUrl: BASE_URL,
            token: settings.API_KEY,
            type: "NAME",
            hint: "",
            params: {
                parts: ["NAME", "SURNAME"],
            },
            onSelect: function (suggestion, changed) {
                if (callbacks.onSelect) {
                    callbacks.onSelect("name", suggestion, changed);
                }
            },
        });
    },
    email: function ($element, callbacks) {
        $element.suggestions({
            serviceUrl: BASE_URL,
            token: settings.API_KEY,
            type: "EMAIL",
            hint: "",
            suggest_local: false,
            onSelect: function (suggestion, changed) {
                if (callbacks.onSelect) {
                    callbacks.onSelect("email", suggestion, changed);
                }
            },
        });
    },
    party: function ($element, callbacks) {
        $element.suggestions({
            serviceUrl: BASE_URL,
            token: settings.API_KEY,
            type: "PARTY",
            hint: "",
            onSelect: function (suggestion, changed) {
                if (callbacks.onSelect) {
                    callbacks.onSelect("party", suggestion, changed);
                }
            },
        });
    },
    address: function ($element, callbacks) {
        $element.suggestions({
            serviceUrl: BASE_URL,
            token: settings.API_KEY,
            type: "ADDRESS",
            hint: "",
            noSuggestionsHint: false,
            onSelect: function (suggestion, changed) {
                if (callbacks.onSelect) {
                    callbacks.onSelect("address", suggestion, changed);
                }
            },
            onSearchComplete: function (query, suggestions) {
                if (callbacks.onSearchComplete) {
                    callbacks.onSearchComplete("address", query, suggestions);
                }
            },
        });
    },
};

$(init);

export default { init: init, initForElement: initForElement };
